// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// import VCharts from 'v-charts'
import '@/routeGuard'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import VueLazyload from 'vue-lazyload'
import VuePhotoZoomPro from "vue-photo-zoom-pro"


import {
    InputNumber,
    Pagination,
    Cascader,
    Select,
    Option,
    Timeline,
    TimelineItem,
    Card,
    Menu,
    MenuItem,
    Form,
    FormItem,
    Dialog,
    Input,
    RadioGroup,
    Radio,
    Table,
    TableColumn,
    DatePicker,
    Autocomplete
} from 'element-ui'

import 'element-ui/lib/theme-chalk/index.css'

Vue.use(InputNumber)
Vue.use(Pagination)
Vue.use(Cascader)
Vue.use(Select)
Vue.use(Option)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Card)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Dialog)
Vue.use(Input)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(DatePicker)
Vue.use(Autocomplete)
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

Vue.use(VueLazyload, {
    preLoad: 1.3, // 预加载高度的比例
    error: 'static/error.png', //加载错误
    loading: 'static/loading.gif',//加载中
    attempt: 3, // 尝试加载次数
})
Vue.use(VuePhotoZoomPro)
// Vue.use(VCharts)
// Vue.use(VueAwesomeSwiper)

import echarts from 'echarts'

Vue.prototype.$echarts = echarts


import "@/assets/icon/iconfont.css"

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js